const associateUser = () => import('./associateUserPage.vue');

export default [
  {
    path: '/management/associate-user',
    name: 'associateUser',
    component: associateUser
  }
];
